import { createSelector } from '@reduxjs/toolkit';

const selectStatement = (state) => state.statement;

const selectPrinting = () => createSelector(selectStatement, (state) => state.printing);

export default selectPrinting;
